import { NoSsr } from '@bygghemmait/components';
import { useRef } from 'react';
import { createPortal } from 'react-dom';

export interface PortalProps {
  container?: () => HTMLElement | null;
  children?: React.ReactNode;
}

const ClientPortal = ({ children, container }: PortalProps): JSX.Element | null => {
  const target = useRef<HTMLElement>(container?.() ?? document.body);
  return target.current ? createPortal(children, target.current) : null;
};

const Portal = (props: PortalProps): JSX.Element => (
  <NoSsr defer>
    <ClientPortal {...props} />
  </NoSsr>
);

export default Portal;
